import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { VueEditor } from 'vue2-editor'
import codes from '@/f1/codes';
import { api } from '@/f1/service';

//i18n_data
import i18n_data from '@/component/i18n_data';

const default_model = () => ({ is_alive: true });

export default {
  components: { VueEditor, cSwitch, vSelect },
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      allowed: false,
      codes
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'notice', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'notice', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.board.notice.delete(this.model.id);
        this.$parent.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data || e); this.list(); }
    },
    back() { this.list() },
    list() { this.$router.push({ name: 'notice'}); },
    async save() {
      if(!(this.model.content || '').trim()) { return this.$toastr.e(`${i18n_data._i18n_error.content[this.i18n]}`); }
      try {
        if(this.model.id) { await api.board.notice.update(this.model.id, this.model); }
        else { this.model.id = +(await api.board.notice.write(this.model)); }
        this.$toastr.s('Done.'); this.$parent.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] notice.detail', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      // try { this.model = Object.assign({}, this.model, await api.board.notice.get(id)); }
      try { let rs = await api.board.Board_Call('notice', 'detail', { id : id }); console.log(rs); this.model = rs.body }
      catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('[vue] notice.detail', 'created'); },
  destroyed() { console.log('[vue] notice.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] notice.detail', 'mounted');
    this.get(this.$route.params);
  },
}
